import styled from 'styled-components';
import { outlineGray } from '../../config/colors';

export const SearchInput = styled.input`
  width: 100%;
  height: 40px;
  border: 2px solid ${outlineGray};
  border-radius: 3px;
  padding: 5px 10px;
  font-size: 0.875rem;
  text-align: start;
`;
